import { AxiosRequestConfig } from 'axios';
import { HttpResponse, ajax } from '../../../../common/ajax';
import { config } from '../../config';
import {
  ContactFormDetailsModel,
  HelpContactCommand,
  HelpMenuItemModel,
  HelpSectionDetailsModel,
  HelpSectionItemModel,
} from '../../models/Help';

interface IHelpService {
  getHelpMenu: (
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<HelpMenuItemModel[]>>;
  getHelpSections: (
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<HelpSectionItemModel[]>>;
  getHelpSectionDetails: (
    sectionId: number,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<HelpSectionDetailsModel>>;
  rateHelpSection: (
    sectionId: number,
    isPositive: boolean,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<boolean>>;
  getContactFormDetails: (
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<ContactFormDetailsModel>>;
  contact: (
    data: HelpContactCommand,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<boolean>>;
}

export const helpService: IHelpService = {
  getHelpMenu(axiosConfig) {
    return ajax.get<HelpMenuItemModel[]>(
      `${config.benefitApiUrl}/help/menu`,
      axiosConfig,
    );
  },
  getHelpSections(axiosConfig) {
    return ajax.get<HelpSectionItemModel[]>(
      `${config.benefitApiUrl}/help/sections`,
      axiosConfig,
    );
  },
  getHelpSectionDetails(sectionId, axiosConfig) {
    return ajax.get<HelpSectionDetailsModel>(
      `${config.benefitApiUrl}/help/sections/${sectionId}`,
      axiosConfig,
    );
  },
  rateHelpSection(sectionId, isPositive, axiosConfig) {
    return ajax.put<boolean>(
      `${config.benefitApiUrl}/help/sections/${sectionId}`,
      { sectionId, isPositive },
      axiosConfig,
    );
  },
  getContactFormDetails(axiosConfig) {
    return ajax.get<ContactFormDetailsModel>(
      `${config.benefitApiUrl}/help/contact`,
      axiosConfig,
    );
  },
  contact(data, axiosConfig) {
    return ajax.post<boolean>(
      `${config.benefitApiUrl}/help/contact`,
      data,
      axiosConfig,
    );
  },
};
